import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Spin, Upload } from 'antd';
import Button from '../../common/Button';
import Input from '../../common/AntInput';
import Select from '../../common/Select';
import { Link } from 'react-router-dom';
import { openNotification } from '../../../helpers/notification';
import { withRouter } from 'react-router';
import ConfirmSignupModal from './ConfirmSignupModal';
import './style.css';
import { Box, Chip, Grid2, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { signupConsultant } from '../../../helpers/api';
import { useHistory } from 'react-router-dom';

const { Option } = Select;

const SignupForm = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const nigDialCode = '+234';

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);


  useEffect(() => {
    handleInitFormValues();
  }, []);

  const handleInitFormValues = () => {
    form.setFieldsValue({
      email: '',
      firstname: '',
      lastname: '',
      mobileno: '',
      gender: 'm',
      membershipId: '',
      membershipIdExpiry: '',
    });
  };

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const closeModal = () => {
    setVisible(false);
    history.push('signin');
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      console.log('values', values);

      let phoneNumber = values?.mobileno;
      if (!phoneNumber) {
        openNotification({ status: 'error', title: 'Phone number is required' });
      }

      if (phoneNumber?.charAt(0) === '0') {
        phoneNumber = phoneNumber?.slice(1);
      }

      const fullPhoneNumber = `${nigDialCode?.slice(1)}${phoneNumber}`;

      if (fullPhoneNumber?.length > 13 || phoneNumber < 13) {
        openNotification({
          type: 'error',
          title: `Phone Number (${fullPhoneNumber}) is possibly incorrect`,
        });
      }

      const formData = new FormData();
      formData.append('Username', values?.email);
      formData.append('EmailAddress', values?.email);
      formData.append('Password', values?.password);
      formData.append('Firstname', values?.firstname);
      formData.append('Lastname', values?.lastname);
      formData.append('MobileNo', fullPhoneNumber);
      formData.append('Gender', values?.gender);
      formData.append('Title', "Onboarding Document");
      formData.append('ConsultantMembershipId', values?.membershipId);
      formData.append('ConsultantMembershipIdExpiry', values?.membershipIdExpiry);

      if (fileList?.length > 0) {
        const file = fileList[0].originFileObj;
        formData.append('Document', file);
      }

      const res = await signupConsultant(formData);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setVisible(true);
      } else {
        openNotification({
          type: 'error',
          title: status?.desc,
        });
      }
    } catch (error) {
      const errMsg = error?.data?.result?.desc;
      openNotification({
        type: 'error',
        title: errMsg,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <ConfirmSignupModal open={visible} close={closeModal} />
      <br />

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Grid2 container spacing={1}>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }} marginBottom={2}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h4" color="textSecondary" fontWeight={600}>
                Get Started On IEMS
              </Typography>
              <Chip label="Only for Consultants" color="warning" sx={{ ml: 'auto' }} />
            </Box>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              name="email"
              label="Email Address"
              style={{ marginBottom: 0 }}
              rules={[{ required: true }]}
            >
              <Input
                type="email"
                placeholder="Enter valid Email Address"
                className="signup__input"
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Password"
              name="password"
              style={{ marginBottom: 10 }}
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
                    if (!value || (value && regex.test(value)) || value.length < 6) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      'Password should not be shorter than 6 characters and should include at least one number and one capital and small letter'
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                type="password"
                className="signup__input"
                placeholder="Enter unique password"
                required
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="First Name"
              name="firstname"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please enter first name' }]}
            >
              <Input type="text" placeholder="Enter first name here" className="signup__input" />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Last Name"
              name="lastname"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please enter last name ' }]}
            >
              <Input type="text" placeholder="Enter last name here" className="signup__input" />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Phone Number"
              className="phonenumber__input"
              name="mobileno"
              style={{ marginBottom: 0 }}
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    if (!value || (value && regex.test(value))) {
                      return Promise.resolve();
                    }
                    return Promise.reject('The input is not a valid phone number!');
                  },
                }),
              ]}
            >
              <Input
                addonBefore={nigDialCode}
                placeholder="8039997654"
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Gender"
              name="gender"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please select a gender  ' }]}
            >
              <Select className="signup__input">
                <Option value="m">Male</Option>
                <Option value="f">Female</Option>
              </Select>
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              name="membershipId"
              label="Membership Identification No."
              style={{ marginBottom: 0 }}
            >
              <Input
                type="text"
                placeholder="Enter membership identification no."
                className="signup__input"
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              name="membershipIdExpiry"
              label="Membership Identification Expiry"
              style={{ marginBottom: 0 }}
            >
              <Input
                type="date"
                placeholder="Enter membership identification Expiry."
                className="signup__input"
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Upload
              listType="picture-card"
              fileList={fileList}
              onChange={handleFileChange}
              beforeUpload={() => false} // Prevent default upload behavior
            >
              {fileList.length < 1 && (
                <div>
                  <Add />
                  <div style={{}}>Upload Membership Document</div>
                </div>
              )}
            </Upload>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item
              label=""
              name="terms"
              valuePropName="checked"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please agree to terms & conditions to proceed' }]}
            >
              <Checkbox required>Agree to terms & conditions</Checkbox>
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button appearance="blue" size="large" disabled={loading}>
                {loading && <Spin />} &nbsp; Sign Up
              </Button>
            </Form.Item>
            <Box mt={2}>
              <Typography component={'span'} variant="body2">
                Already have an account?{' '}
              </Typography>
              &nbsp;
              <Typography component={'span'} variant="body2" color="primary" fontWeight={600}>
                <Link to="/signin">Sign in </Link>
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Form>
      <br />
    </Box>
  );
};

export default withRouter(SignupForm);
